import { FC, memo } from 'react'
import { InputProps, OutlinedInput, Typography } from '@mui/material'
import { FormControl } from './labeledInputV2.styles'

export type LabeledInputV2Props = InputProps & {
  label: string
  helperText?: string
}

/* The UI library's Input: a label above a 48px outlined field carrying the
 * shared default / hover / focus / disabled / error border states. */
const LabeledInputV2: FC<LabeledInputV2Props> = ({ label, helperText, ...rest }) => (
  <FormControl iserrored={helperText ? 'true' : 'false'}>
    <Typography className="input-label">{label}</Typography>
    <OutlinedInput {...rest} error={!!helperText} />
    {!!helperText && <Typography className="helper-text">{helperText}</Typography>}
  </FormControl>
)

export default memo(LabeledInputV2)
